import { bankAccountStatusResponseSchema } from '@/api/UK/me/schemas';
import { apiRequest } from '@/api/utils/api';

export const getBankAccountStatus = () =>
  apiRequest({
    url: '/uk/me/bank-account/status',
    method: 'GET',
    schema: bankAccountStatusResponseSchema,
  });
